import request from '@/utils/http';

// 二级节点api
// 产品模板-搜索查询
export const queryTemplate = (params) => {
    return request({
        url: '/api-sn/product/productTemplates/searchPage',
        method: 'post',
        data: params
    }).then(res => res);
};

// 产品模板-查询详情
export const templateDetails = (params) => {
    return request({
        url: '/api-sn/product/productTemplates/queryById',
        method: 'post',
        data: params
    }).then(res => res);
};

// 产品模板-新增修改
export const templateChange = (params) => {
    return request({
        url: '/api-sn/product/productTemplates/save',
        method: 'post',
        data: params
    }).then(res => res);
};

// 产品模板-首页状态
export const templateState = (params) => {
    return request({
        url: '/api-sn/product/productTemplates/enable',
        method: 'post',
        data: params
    }).then(res => res);
};

// 上传模板
export const templateUpload = (params) => {
    return request({
        url: '/api-sn/product/productTemplates/upload',
        method: 'post',
        data: params
    }).then(res => res);
};

// 产品维护主页-查询
export const productSearch = (params) => {
    return request({
        url: '/api-sn/product/searchPage',
        method: 'post',
        data: params
    }).then(res => res);
};

// 产品维护界面-启用禁用
export const maintainingState = (params) => {
    return request({
        url: '/api-sn/product/enable',
        method: 'post',
        data: params
    }).then(res => res);
};

// 产品维护页面-跳转到维护单个页面，进入页面的查询
export const managementInquiry = (params) => {
    return request({
        url: '/api-sn/product/queryById',
        method: 'post',
        data: params
    }).then(res => res);
};
// 产品维护页面-保存、修改
export const managementSave = (params) => {
    return request({
        url: '/api-sn/product/save',
        method: 'post',
        data: params
    }).then(res => res);
};

// 产品-视频上传
export const uploadPictures = (params) => {
    return request({
        url: '/api-file/snFile/uploadPublicRead',
        method: 'post',
        data: params
    }).then(res => res);
};